// Stroke icons for the sidebar (design v0.9, V4): one per item, drawn inline
// so the rail can fold to icons only. Decorative: the label beside each one
// (visible, or read out when the rail is folded) names it.

const P: Record<string, string> = {
  decisions: "M9 12l2 2 4-4M5 4h14v16H5z",
  inbox: "M4 13h4l2 3h4l2-3h4M4 13l2-8h12l2 8v6H4z",
  tasks: "M9 6h11M9 12h11M9 18h11M4 6l1 1 2-2M4 12l1 1 2-2M4 18l1 1 2-2",
  recruiting: "M16 11a4 4 0 1 0-8 0 4 4 0 0 0 8 0zM4 21c1-4 4-6 8-6s7 2 8 6",
  clients: "M4 21V7l8-4 8 4v14M9 21v-6h6v6M8 10h2M14 10h2",
  "back-office": "M4 7h16v13H4zM9 7V4h6v3M4 12h16",
  reports: "M5 20V10M12 20V4M19 20v-7",
  ai: "M12 3l2.5 5.5L20 11l-5.5 2.5L12 19l-2.5-5.5L4 11l5.5-2.5z",
  admin:
    "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z",
  add: "M12 5v14M5 12h14",
  fold: "M15 6l-6 6 6 6",
  unfold: "M9 6l6 6-6 6",
  item: "M8 12h8",
};

const BY_PATH: Record<string, string> = {
  "/decisions": "decisions",
  "/inbox": "inbox",
  "/tasks": "tasks",
  "/reports": "reports",
};

export function Icon({ name, size = 18 }: { name: string; size?: number }) {
  return (
    <svg
      className="rail-icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={P[name] ?? P.item} />
    </svg>
  );
}

export const iconFor = (to: string) => BY_PATH[to] ?? "item";
